import './index.scss';
import './antd.css';
import 'react-spring-bottom-sheet/dist/style.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import React from 'react';

import { CookiesProvider } from 'react-cookie';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { QueryClientProvider } from '@tanstack/react-query';

import App from './App';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import AppProvider from './context/AppProvider';
import { CommunitySocketProvider } from './context/CommunitySocketProvider';
// import { SocketProvider } from './context/SocketProvider';
import { store } from './context/store';
import ThemeProvider from './context/ThemeProvider';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { BASENAME } from './shared/data';
import { queryClient } from './shared/queryClient';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <BrowserRouter basename={BASENAME}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <Provider store={store}>
            <CookiesProvider>
              <CommunitySocketProvider>
                {/* <SocketProvider> */}
                <AppProvider>
                  <App />
                </AppProvider>
                {/* </SocketProvider> */}
              </CommunitySocketProvider>
            </CookiesProvider>
          </Provider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </ErrorBoundary>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
